<script>
  import Select from "svelte-select";
  import RestAirports from "./RestAirports.svelte";
  import SelectAirportItem from "./SelectAirportItem.svelte";

  export let selectedValue = undefined; // n.b. object
  export let placeholder = "Search...";
  export let noOptionsMessage = "No results";
  export let isClearable = true;
  export let showChevron = true;
  export let onChange = () => {};
  export let onClear = () => {};

  let restAirports = null;

  function getAirports(filterText) {
    if (filterText.length < 3) {
      return new Promise((resolve, reject) => {
        resolve([]);
      });
    }

    return restAirports.GetAirportSearch(filterText);
  }
</script>

<style>
  /*   input:not([type]):focus:not([readonly]),
  input[type="text"]:not(.browser-default):focus:not([readonly]),
  input[type="password"]:not(.browser-default):focus:not([readonly]),
  input[type="email"]:not(.browser-default):focus:not([readonly]),
  input[type="url"]:not(.browser-default):focus:not([readonly]),
  input[type="time"]:not(.browser-default):focus:not([readonly]),
  input[type="date"]:not(.browser-default):focus:not([readonly]),
  input[type="datetime"]:not(.browser-default):focus:not([readonly]),
  input[type="datetime-local"]:not(.browser-default):focus:not([readonly]),
  input[type="tel"]:not(.browser-default):focus:not([readonly]),
  input[type="number"]:not(.browser-default):focus:not([readonly]),
  input[type="search"]:not(.browser-default):focus:not([readonly]),
  textarea.materialize-textarea:focus:not([readonly]) {
    box-shadow: none !important;
  } */
</style>

<Select
  loadOptions={getAirports}
  bind:selectedValue
  {placeholder}
  {noOptionsMessage}
  hideEmptyState={true}
  {isClearable}
  {showChevron}
  isSearchable={true}
  optionIdentifier="airportid"
  getOptionLabel={airport => airport.gps_code + ' - ' + airport.name}
  getSelectionLabel={airport => airport.gps_code + ' - ' + airport.name}
  Item={SelectAirportItem}
  on:select={onChange}
  on:clear={onClear} />

<RestAirports bind:this={restAirports} />
